/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lang: NonNullable<unknown> }} Profile_Remove_LanguageInputs */



/**
* | output |
* | --- |
* | "Remove {lang}" |
*
* @param {Profile_Remove_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_remove_language = /** @type {((inputs: Profile_Remove_LanguageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Remove_LanguageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Retirer ${i?.lang}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Quitar ${i?.lang}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Remover ${i?.lang}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovi ${i?.lang}`)
	return /** @type {LocalizedString} */ (`Remove ${i?.lang}`)
});